import { combineReducers } from '@reduxjs/toolkit';
import { networkStatusReducer } from 'data-layer-cr/dist/network';
import dynamicRenderReducer from 'data-layer-cr/dist/slices/dynamicRender';
import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import applicationReducer from './application';
import carReducer from './car/slice';
import catalogReducer from './catalogs/slice';
import coverageReducer from './coverage/slice';
import customerReducer from './customer/slice';
import emissionReducer from './emission/slice';
import infiniteScrollReducer from './infiniteScroll/slice';
import inspectionReducer from './inspection/slice';
import metricReducer from './metric/slice';
import notificationReducer, { NotificationState } from './notification/slice';
import personalAgentLinkReducer from './personalAgentLink/slice';
import policyReducer from './policy/slice';
import pricingPackagesReducer from './pricingPackages/slice';
import pricingProfileReducer from './pricingProfiles/slice';
import profileReducer from './profile/slice';
import quotationReducer from './quotation/slice';
import steppersSliceReducer from './steppers/slice';

const notificationPersist: PersistConfig<NotificationState> = {
  key: 'notificationData',
  storage,
  whitelist: ['filterUnderstood', 'policyMenuUnderstood'],
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const rootReducer = combineReducers({
  personalLink: personalAgentLinkReducer,
  networkStatus: networkStatusReducer,
  profile: profileReducer,
  catalog: catalogReducer,
  customer: customerReducer,
  car: carReducer,
  quotation: quotationReducer,
  coverage: coverageReducer,
  application: applicationReducer,
  pricingPackages: pricingPackagesReducer,
  stepper: steppersSliceReducer,
  infiniteScroll: infiniteScrollReducer,
  inspection: inspectionReducer,
  pricingProfiles: pricingProfileReducer,
  dynamicRender: dynamicRenderReducer,
  emission: emissionReducer,
  metric: metricReducer,
  notification: persistReducer<NotificationState>(
    notificationPersist,
    notificationReducer,
  ),
  policy: policyReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
